import { render, staticRenderFns } from "./LocationAdministration.vue?vue&type=template&id=304a24d2&"
import script from "./LocationAdministration.vue?vue&type=script&lang=js&"
export * from "./LocationAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LocationAdministration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304a24d2')) {
      api.createRecord('304a24d2', component.options)
    } else {
      api.reload('304a24d2', component.options)
    }
    module.hot.accept("./LocationAdministration.vue?vue&type=template&id=304a24d2&", function () {
      api.rerender('304a24d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LocationAdministration.vue"
export default component.exports